<template>
  <div>
    <h1>
      <b>Marcas</b>
    </h1>
    <div class="form-group pull-left">
      <button
        @click="showModal"
        class="btn btn-success md-elevation-24"
      >
        <i class="fa fa-plus-circle"></i> Crear marcar
      </button>
    </div>
    <div>
      <div class="form-group pull-right">
        <input
          type="text"
          class="search form-control"
          v-model="filter"
          placeholder="Buscar marca"
        />
      </div>
      <span class="counter pull-right"></span>
      <div class="row">
        <div id="table" class="col-xs-12 table-responsive">
          <datatable
            :columns="columns"
            :data="row"
            :filter-by="filter"
            class="table table-hover table-bordered results"
          >
            <template scope="{ row }">
              <tr>
                <td class="td_style">{{ row.id }}</td>
                <td class="td_style">{{ `${row.marca}` }}</td>
                <td class="td_style">
                  <button
                    @click="eliminar(row.id)"
                    class="btn btn-danger"
                  >
                    <i class="fa fa-trash"></i> Eliminar
                  </button>
                  |
                  <button
                    @click="showModalEditMarca(row.id, row.marca)"
                    class="btn btn-primary"
                  >
                    <i class="fa fa-edit"></i> Editar
                  </button>
                </td>
              </tr>
            </template>
          </datatable>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 form-inline">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
          ></datatable-pager>
        </div>
      </div>
    </div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :on-cancel="onCancel"
      loader="dots"
      color="#164880"
      :is-full-page="true"
    ></loading>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ServiceApi from '../../ServiceApi';
import Loading from 'vue-loading-overlay';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
  name: 'marcas',
  components: {
    Loading,
  },
  computed: mapState(['topicSocket']),
  data() {
    return {
      filter: '',
      loading: true,
      columns: [
        {
          label: 'ID',
          field: 'id',
          align: 'center',
        },
        {
          label: 'MARCA',
          field: 'marca',
          align: 'center',
        },
        { label: 'ACCIONES', align: 'center' },
      ],
      row: [],
      page: 1,
      per_page: 20,
    };
  },
  created() {
    this.getMarcas();
  },
  mounted() {},
  methods: {
    onCancel() {},
    eliminar(marcaId) {
      let data = {
        marcaId,
      };
      ServiceApi.post('/marca/delete', data)
        .then(response => {
          this.getMarcas();
        })
        .catch(err => {
          this.$noty.error(
            'Posiblemente la marca tiene asociaciones en base de datos, no es posible borrarla'
          );
          this.loading = false;
        });
    },
    getMarcas() {
      this.loading = true;
      ServiceApi.get('/marcas/list')
        .then(response => {
          //console.log('RESPUESTA:::', response)
          let data = response.data.data;
          this.row = data.reverse().filter(d => d.marca != 'NINGUNA');
          if (!data.length)
            this.$noty.warning('No se encontraron marcas creadas');
          this.loading = false;
        })
        .catch(err => {
          this.$noty.error(
            'Ocurrio un error al consultar los usuarios'
          );
          this.loading = false;
          this.$router.push('/');
        });
    },
    showModal() {
      const { value: marca } = Swal.fire({
        title: 'Digita el nombre de la marca',
        input: 'text',
        inputPlaceholder: 'Ingresa nombre de la marca',
        confirmButtonText: 'Guardar',
      }).then(response => {
        response.value != undefined || response.value != null
          ? this.saveInformation(response.value)
          : '';
      });
    },
    showModalEditMarca(marcaId, marcaName) {
      const { value: marca } = Swal.fire({
        title: 'Digita el nombre de la marca',
        input: 'text',
        inputPlaceholder: `${marcaName}`,
        confirmButtonText: 'Guardar',
      })
        .then(response => {
          if (response.value != '') {
            this.loading = true;
            let data = {
              marcaId: marcaId,
              marca: response.value.toUpperCase(),
            };
            ServiceApi.post('/marca/update', data)
              .then(response => {
                this.getMarcas();
              })
              .catch(err => {
                this.$noty.error(
                  'Ocurrio un error al editar la marca'
                );
                this.loading = false;
              });
          } else {
            this.$noty.warning(
              'Debes ingresar el nuevo nombre de la marca'
            );
          }
        })
        .catch(e => (this.loading = false));
    },
    saveInformation(marca) {
      this.loading = true;
      let data = {
        marca: marca.toUpperCase(),
      };
      ServiceApi.post('/marca/create', data)
        .then(response => {
          this.getMarcas();
        })
        .catch(err => {
          this.$noty.error('Ocurrio un error al crear la marca');
          this.loading = false;
        });
    },
  },
};
</script>
